import { IMigrationInfo } from '../../../masters_management/utility'
import { Box } from '@mui/material'
import * as React from 'react'

export function MigrationStatusInfo({
  migrationInfo: { info, errors },
}: {
  migrationInfo: IMigrationInfo
}) {
  return (
    <Box>
      {!!info.length && (
        <Box>
          {info.map((i) => (
            <Box key={i}>{i}</Box>
          ))}
        </Box>
      )}
      {!!errors.length && (
        <Box>
          {errors.map((i) => (
            <Box key={i}>{i}</Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
